import { api } from '../../store/api';

// ---------- 型定義 ----------

export interface OperationLogItem {
  log_id: string;
  timestamp: string;
  action: string;
  user_id: string;
  detail: Record<string, unknown>;
  ip_address: string;
  source?: string;
  service?: string;
  environment?: string;
  version?: string;
}

interface GetLogsResponse {
  status: string;
  count?: number;
  logs?: OperationLogItem[];
  message?: string;
}

export interface GetLogsParams {
  action?: string;
  user_id?: string;
  limit?: number;
}

// ---------- action → 日本語ラベル ----------

const ACTION_LABEL_MAP: Record<string, string> = {
  file_upload: 'アップロード',
  page_view: 'ページ閲覧',
  click: 'クリック',
  form_submit: 'フォーム送信',
  shift_created: 'シフト作成',
  login: 'ログイン',
  logout: 'ログアウト',
  error: 'エラー',
  api_request: 'APIリクエスト',
};

export const resolveActionLabel = (action: string): string =>
  ACTION_LABEL_MAP[action] ?? action;

// ---------- エンドポイント ----------

const operationLogsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOperationLogs: builder.query<GetLogsResponse, GetLogsParams>({
      query: ({ action, user_id, limit = 100 } = {}) => {
        const params = new URLSearchParams();
        if (action) params.set('action', action);
        if (user_id) params.set('user_id', user_id);
        params.set('limit', String(limit));
        return `/logs?${params.toString()}`;
      },
      providesTags: ['OperationLogs'],
    }),
  }),
});

export const { useGetOperationLogsQuery } = operationLogsApi;
